<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">{{ $t("ESTABLISHMENTS.ADD_ESTABLISHMENT") }}</h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <establishment-form
              :loading="loading"
              :establishmentData="establishment"
              :formErrors="formErrors"
              @establishmentSubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultEstablishment from "./defaultEstablishment";
import EstablishmentForm from "./partials/EstablishmentForm.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    EstablishmentForm,
  },

  mixins: [alertLeave],

  data() {
    const establishment = cloneDeep(defaultEstablishment);
    return {
      establishment: establishment,
      formErrors: null,
      loading: false,
    };
  },

  methods: {
    goBack() {
      this.$router.push({ name: "List Establishments" });
    },

    viewEstablishment(establishment) {
      this.alertLeave = false;
      this.$router.push({
        name: "View Establishment",
        params: { id: establishment.id },
      });
    },

    async handleSubmit(establishment) {
      this.loading = true;
      const establishmentData = cloneDeep(establishment);

      try {
        await this.$store.dispatch("establishments/add", establishmentData);
        this.$notify({
          type: "success",
          message: this.$t("ESTABLISHMENTS.ESTABLISHMENT_ADDED"),
        });
        const establishment = await this.$store.getters[
          "establishments/establishment"
        ];
        this.viewEstablishment(establishment);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
